import axios from 'axios'
import utils from '@/utils/index'
import p from '@/utils/secretkey/pfingerprint'
import Fingerprint2 from 'fingerprintjs2' // 引入fingerprintjs2
import conf from '@/utils/config/index'
import store from '@/store'
import router from '@/router'
import { eventBus } from '@/utils/event-bus'
import { initMyDialog } from '@/components/dialog/handleDialog'
import { loginOutAPI } from '@/axios/common'
let root = process.env.NODE_ENV === 'development' ? '/api' : conf.getApiUrl
let myDialogIsShow = false
async function createFingerprint() {
  // 选择哪些信息作为浏览器指纹生成的依据
  const options = {
    fonts: {
      extendedJsFonts: true,
    },
    excludes: {
      audio: true,
      userAgent: true,
      enumerateDevices: true,
      touchSupport: true,
    },
  }

  // 使用 Promise 包装 Fingerprint2.get，以便能够等待它完成
  const fingerprint = new Promise(resolve => {
    Fingerprint2.get(options, components => {
      const values = components.map(component =>
        component.key != 'pixelRatio' ? component.value : ''
      )
      const murmur = Fingerprint2.x64hash128(
        values.join('') + window.location.host,
        31
      )
      resolve(murmur)
    })
  })
  // 1. 获取12位的aes key
  var ak = utils.genak()

  const murmur = await fingerprint

  let row = {
    device_key: murmur,
  }
  var parGfans = utils.secret(row, ak)
  var ptoGfans = utils.re(ak, unescape(escape(p)))
  if (!localStorage.getItem('parGfans')) {
    localStorage.setItem('parGfans', parGfans)
    localStorage.setItem('ptoGfans', ptoGfans)
  }
}
async function loginOut(row) {
  try {
    const res = await loginOutAPI()
    // 执行操作
    localStorage.removeItem('platfro')
    localStorage.removeItem('gfansLogin')
    localStorage.removeItem('authtoken1')
    localStorage.removeItem('noticeActive')
    utils.clearCookie(conf.fmCookieName)
    store.commit('setAttr', { name: 'userInfo', val: {} })
    store.commit('setAttr', { name: 'isLogin', val: 0 })
    store.commit('setAttr', { name: 'isPage', val: 1 })
    store.commit('setAttr', { name: 'isapp', val: 1 })
    this.$store.commit('setAttr', { name: 'collectTotal', val: 0 })
    this.$store.commit('setAttr', { name: 'collectPost', val: 0 })
    this.$store.commit('setAttr', { name: 'collectVideo', val: 0 })
    eventBus.$emit('upHomeList')
    eventBus.$emit('upHotList')
    // eventBus.$emit('appReload')
    if (row == 1) {
      // 当前设备已被下线，如非本人操作请及时修改密码，避免所存储的数据丢失
      eventBus.$emit('showLogin', {})
    } else {
      // 请先登录和请重新登录
      let routeName = router.currentRoute.name
      // 当路由不是 home、tab、jx、vd 时才显示登录
      if (!['home', 'tab', 'jx', 'vd'].includes(routeName)) {
        eventBus.$emit('showLogin', {})
      }
    }
    // 仅当路由不是 tab、jx、vd 时才跳转
    if (!['tab', 'jx', 'vd'].includes(routeName)) {
      router.push({ path: '/discover' })
    }
    // let path = router.currentRoute.path.toString().slice(1)
    // const from = 'gfans'
    // const fromUrl = conf.jmdyhUrl + `/${path}`
    // const encodedFrom = encodeURIComponent(from)
    // const encodedFromUrl = encodeURIComponent(fromUrl)
    // window.location.href =
    //   conf.feemooUrl + `/login?from=${encodedFrom}&fromUrl=${encodedFromUrl}`
    return res // 返回结果
  } catch (error) {}
}
await createFingerprint()
const service = axios.create({
  baseURL: root + '/index.php/',
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    par: localStorage.getItem('parGfans'),
    pto: localStorage.getItem('ptoGfans'),
    os: 'pc',
  },
})

service.interceptors.request.use(config => {
  // 每次请求前动态获取最新的AuthToken
  config.headers['AuthToken'] = localStorage.getItem('authtoken1') || ''
  if (config.method === 'post') {
    // 将 JSON 数据转换为 FormData
    const formData = new FormData()
    for (const key in config.data) {
      formData.append(key, config.data[key])
    }
    // 更新请求配置，使用 FormData 格式的数据
    config.data = formData

    // 更新请求头，指定使用 FormData 格式
    // config.headers["Content-Type"] = "multipart/form-data";
  }
  return config
})

service.interceptors.response.use(
  async response => {
    //清空pto2
    if (response.data?.status == 40100) {
      localStorage.removeItem('parGfans')
      localStorage.removeItem('ptoGfans')
      createFingerprint()
    } else if (response.data?.status == 1012) {
      // 当前设备已被下线，如非本人操作请及时修改密码，避免所存储的数据丢失
      if (!myDialogIsShow) {
        myDialogIsShow = true
        const myDialog = initMyDialog()
        myDialog.show(
          {
            title: '安全提示',
            content: response.data.msg,
            btn: '重新登录',
            isClose: false,
          },
          async () => {
            myDialogIsShow = false
            await loginOut(1)
          }
        )
      }
      return
    } else if (response.data?.status == 1014 || response.data?.status == 1010) {
      //请先登录和请重新登录
      await loginOut(2)
      // return
    } else if (response.data?.status == 1015) {
      //请先登录和请重新登录 但是需要弹出引导登录弹窗
      await loginOut(1)
      // return
    }
    return response.data
  },
  err => {
    return {
      status: -1,
    }
    // return Promise.reject(error);
  }
)

export default service
